// extracted by mini-css-extract-plugin
export default {"container_relatorio":"RelatorioFreguesia_container_relatorio__u6cHp","container_row":"RelatorioFreguesia_container_row__sJxow"};